var _rect, _path, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUrl = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 36,
  x: 9,
  y: 2,
  fill: "#EBEBEB",
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C8C8C8",
  d: "M9 29h30v7a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDD",
  d: "M30 29V2h7a2 2 0 0 1 2 2v25z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 19.5,
  x: 1,
  y: 11,
  fill: "#291446",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.85 17.61v4.28q0 1.01.36 1.51.37.49 1.24.49.86 0 1.21-.49.36-.5.36-1.51v-4.28h1.21v4.28q0 .83-.2 1.41-.2.57-.57.94-.37.36-.88.52-.51.17-1.14.17-1.37 0-2.08-.73-.71-.74-.71-2.34v-4.25zm8.325 3.3q.41 0 .68-.08.27-.09.42-.24a.84.84 0 0 0 .22-.38q.07-.22.07-.49 0-.25-.08-.45a.73.73 0 0 0-.25-.35 1.15 1.15 0 0 0-.46-.23 2.8 2.8 0 0 0-.72-.08h-1.22v2.3zm-.09-3.3q.81 0 1.33.19.53.19.83.5.31.3.43.67t.12.73q0 .7-.28 1.17-.27.47-.88.76l1.48 3.12h-1.32l-1.28-2.84-.19.02h-1.49v2.82h-1.19v-7.14zm5.195 0v6.09h3.54l-.15 1.05h-4.6v-7.14z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUrl);
export default ForwardRef;